// extracted by mini-css-extract-plugin
export default {"container":"offerList_container__AUGSo","selectable":"offerList_selectable__MO99p"};